import React from 'react';
import FilamentCard from './FilamentCard';
import FilamentGroupCard from './FilamentGroupCard';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FilamentGrid = ({ 
  filaments, 
  groupMode = false,
  loading, 
  onEdit, 
  onViewHistory, 
  onMarkDepleted,
  onAddFilament 
}) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {Array.from({ length: 8 })?.map((_, index) => (
          <div key={index} className="bg-card border border-border rounded-2xl p-6 animate-pulse">
            <div className="flex items-start space-x-4 mb-4">
              <div className="w-16 h-16 bg-muted rounded-lg" />
              <div className="flex-1 space-y-2">
                <div className="h-4 bg-muted rounded w-3/4" />
                <div className="h-3 bg-muted rounded w-1/2" />
              </div>
            </div>
            <div className="space-y-3">
              <div className="h-3 bg-muted rounded" />
              <div className="h-3 bg-muted rounded w-2/3" />
              <div className="h-2 bg-muted rounded" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (filaments?.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4">
        <div className="w-24 h-24 bg-muted rounded-full flex items-center justify-center mb-6">
          <Icon name="Filament" size={32} className="text-muted-foreground" />
        </div>
        
        <h3 className="text-xl font-semibold text-foreground mb-2">
          Nenhum filamento encontrado
        </h3>
        
        <p className="text-muted-foreground text-center mb-8 max-w-md">
          Você ainda não possui filamentos cadastrados ou nenhum filamento corresponde aos filtros aplicados.
        </p>
        
        <Button
          onClick={onAddFilament}
          iconName="Plus"
          iconPosition="left"
          size="lg"
        >
          Adicionar Primeiro Filamento
        </Button>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {filaments?.map((item) => (
        groupMode ? (
          <FilamentGroupCard
            key={item?.groupKey || item?.id}
            group={item}
            onEdit={onEdit}
            onViewHistory={onViewHistory}
            onMarkDepleted={onMarkDepleted}
          />
        ) : (
          <FilamentCard
            key={item?.id}
            filament={item}
            onEdit={onEdit}
            onViewHistory={onViewHistory}
            onMarkDepleted={onMarkDepleted}
          />
        )
      ))}
    </div>
  );
};

export default FilamentGrid;
